import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT ------------------------------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Tag } from "primereact/tag";
import { Dialog } from "primereact/dialog";
import { Password } from "primereact/password";
// import { confirmDialog } from "primereact/confirmdialog";

// ------------------- COMPONENTES DE BASE -----------------------------------------------------
import Card from "../../../../../Base/Components/Card/Card";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import CalendarioOperativo from "../../../../../Base/Components/Form/CalendarioOperativo";
import { toastShow } from "../../../../../Base/Services/ToastService";

// ------------------- CONSULTAS A LA API -------------------------------------------------------
import {
  getAllSolicitudesEdicion,
  UpdSolicitudesEdicion,
} from "../../../../../API/Compras/Proveedores/ProveedoresRequest";

// ------------------ COMPONENTES DE NECESARIOS----------------------------------------------
import ReporteSolicitudEdicionProveedor from "./ReporteSolicitudEdicionProveedores";

const SolicitudEdicionProveedoresScreen = () => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const esRol1 = Number(userAuth?.IdRol) === 1;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dates, setDates] = useState([]);

  const ID_ESTADO_PENDIENTE = 72;
  const ID_ESTADO_APROBADA = 73;
  const ID_ESTADO_REACTIVADA = 74;

  const [showDialogPassword, setShowDialogPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState(null);
  const [validandoPassword, setValidandoPassword] = useState(false);

  const [dialogReporte, setDialogReporte] = useState(false);
  const [reporteData, setReporteData] = useState({
    IdSolicitudEdicion: null,
  });

  const formatDateSQL = (date, finalDia = false) => {
    const fecha = new Date(date);

    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, "0");
    const day = String(fecha.getDate()).padStart(2, "0");

    return `${year}-${month}-${day} ${finalDia ? "23:59:59" : "00:00:00"}`;
  };

  // Función para obtener las solicitudes de edición de proveedores según las fechas seleccionadas
  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      return;
    }
    setLoading(true);

    const fechaInicio = formatDateSQL(dates[0], false);
    const fechaFinal = formatDateSQL(dates[1], true);
    const result = await getAllSolicitudesEdicion(fechaInicio, fechaFinal);
    console.log("SOLICITUDES EDICION:", result?.[0]);

    setData(Array.isArray(result) ? result : []);
    setLoading(false);
  };

  const abrirReporte = (rowData) => {
    setReporteData({
      IdSolicitudEdicion: rowData.IdSolicitudEdicion,
    });

    setDialogReporte(true);
  };

  const hideReporte = () => {
    setDialogReporte(false);

    setReporteData({
      IdSolicitudEdicion: null,
    });
  };

  const aprobarSolicitud = async (rowData) => {
    if (!rowData?.IdSolicitudEdicion) {
      toastShow(toast, "warn", "Advertencia", "No hay solicitud seleccionada.");
      return;
    }

    if (Number(rowData.IdEstado) !== Number(ID_ESTADO_PENDIENTE)) {
      toastShow(
        toast,
        "warn",
        "Acción no permitida",
        `Esta solicitud ya se encuentra en estado: ${rowData.NombreEstado}`,
      );
      return;
    }

    setLoading(true);

    try {
      const result = await UpdSolicitudesEdicion({
        IdSolicitudEdicion: rowData.IdSolicitudEdicion,
        IdEstado: ID_ESTADO_APROBADA,
      });

      const respuesta = Array.isArray(result)
        ? result[0]
        : result?.data?.[0] || result;

      if (respuesta?.ERROR === 0) {
        toastShow(
          toast,
          "success",
          "Correcto",
          respuesta?.MSJ || "Solicitud aprobada correctamente.",
        );

        await getInfo();
      } else {
        toastShow(
          toast,
          "error",
          "Error",
          respuesta?.MSJ || "No se pudo aprobar la solicitud.",
        );
      }
    } catch (error) {
      console.log("ERROR APROBANDO SOLICITUD:", error);

      toastShow(toast, "error", "Error", "No se pudo aprobar la solicitud.");
    } finally {
      setLoading(false);
    }
  };

  const CheckTemplate = (value) => (
    <Checkbox checked={!!value} style={{ marginBottom: 5 }} disabled />
  );

  const hideDialogPassword = () => {
    setShowDialogPassword(false);
    setSolicitudSeleccionada(null);
    setPassword("");
  };

  const columnasSolicitudes = [
    ...(esRol1
      ? [
          {
            field: "IdSolicitudEdicion",
            header: "Id",
            className: "Xsmall",
            filter: true,
          },
          {
            field: "IdProveedor",
            header: "Id Proveedor",
            className: "Xsmall",
            filter: true,
          },
        ]
      : []),

    {
      field: "Correlativo",
      header: "Correlativo",
      className: "small",
      filter: true,
    },
    {
      field: "NombreProveedor",
      header: "Proveedor",
      className: "Xlarge",
      filter: true,
    },
    {
      field: "NombreEstado",
      header: "Estado",
      className: "small",
      Format: "Estado",
      filter: true,
      body: (rowData) => ({
        ID: rowData.IdEstado,
        Estado: rowData.NombreEstado,
      }),
    },
    {
      field: "Comentario",
      header: "Comentario",
      className: "large",
      filter: true,
    },
    {
      field: "NombreUsuario",
      header: "Solicitó",
      className: "small",
      filter: true,
    },
    {
      field: "Autorizó",
      header: "Autorizó",
      className: "small",
      filter: true,
      field: "Autorizo",
    },
    {
      field: "Fecha",
      header: "Fecha",
      className: "medium",
      Format: "Datetime",
      filter: true,
    },

    {
      field: "InformacionEmpresa",
      header: "Empresa",
      className: "Xsmall",
      Format: "Template",
      body: (rowData) => CheckTemplate(rowData.InformacionEmpresa),
      alignFrozen: "right",
    },
    {
      field: "InformacionContacto",
      header: "Contacto",
      className: "Xsmall",
      Format: "Template",
      body: (rowData) => CheckTemplate(rowData.InformacionContacto),
      alignFrozen: "right",
    },
    {
      field: "InformacionBancaria",
      header: "Bancaria",
      className: "Xsmall",
      Format: "Template",
      body: (rowData) => CheckTemplate(rowData.InformacionBancaria),
      alignFrozen: "right",
    },
    {
      field: "InformacionComercial",
      header: "Comercial",
      className: "Xsmall",
      Format: "Template",
      body: (rowData) => CheckTemplate(rowData.InformacionComercial),
      alignFrozen: "right",
    },
    {
      field: "InformacionFinanciera",
      header: "Financiera",
      className: "Xsmall",
      Format: "Template",
      body: (rowData) => CheckTemplate(rowData.InformacionFinanciera),
      alignFrozen: "right",
    },
    {
      field: "Documentacion",
      header: "Documen...",
      className: "Xsmall",
      Format: "Template",
      body: (rowData) => CheckTemplate(rowData.Documentacion),
      alignFrozen: "right",
    },
    {
      field: "Reactivar",
      header: "Reactivar",
      className: "Xsmall",
      Format: "Template",
      body: (rowData) => CheckTemplate(rowData.Reactivar),
      alignFrozen: "right",
    },
    {
      field: "HabilitarPago",
      header: "Habilitar ...",
      className: "Xsmall",
      Format: "Template",
      body: (rowData) => CheckTemplate(rowData.HabilitarPago),
      alignFrozen: "right",
    },
    {
      field: "IdSolicitudEdicion",
      header: "Acciones",
      Format: "Template",
      frozen: true,
      alignFrozen: "right",
      className: "small",
      filter: false,
      body: (rowData) => {
        const estaPendiente =
          Number(rowData?.IdEstado) === Number(ID_ESTADO_PENDIENTE);

        return (
          <div
            className="d-flex gap"
            style={{
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button
              icon="ri-checkbox-circle-line"
              className="p-button-text p-button-sm"
              tooltip={
                estaPendiente
                  ? "Aprobar"
                  : "La solicitud ya fue aprobada o procesada"
              }
              tooltipOptions={{ position: "left" }}
              disabled={!estaPendiente}
              onClick={() => aprobarSolicitud(rowData)}
            />

            <Button
              icon="pi pi-print"
              className="p-button-text p-button-sm"
              tooltip="Imprimir"
              tooltipOptions={{ position: "left" }}
              // disabled={estaPendiente}
              onClick={() => abrirReporte(rowData)}
            />
          </div>
        );
      },
    },
  ];

  const table = {
    Data: data,
    Columns: columnasSolicitudes,
  };

  return (
    <div style={{ width: "99%", height: "90vh" }}>
      <Toast ref={toast} />

      <Loader loading={loading} querySelector="#SolicitudesEdicionProveedor" />

      <Card
        titulo={
          <div className="d-flex gap" style={{ alignItems: "center" }}>
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
              tipo="mesCalendario"
            />

            <Button
              icon="pi pi-search"
              onClick={getInfo}
              loading={loading}
              className="mx-2"
              style={{ height: 35 }}
            />
            <Button
              icon="pi pi-refresh"
              onClick={getInfo}
              loading={loading}
              className="mx-1"
              style={{ height: 35 }}
              tooltip="Refrescar"
              tooltipOptions={{ position: "top" }}
            />
          </div>
        }
        contenido={
          <div
            className="pt-4"
            style={{ height: "85vh" }}
            id="SolicitudesEdicionProveedor"
          >
            <AgGrid table={table} />
          </div>
        }
      />

      <Dialog
        header="Confirmar aprobación"
        visible={showDialogPassword}
        style={{ width: "28rem" }}
        modal
        onHide={hideDialogPassword}
        footer={
          <div className="d-flex justify-content-end gap-2">
            <Button
              label="Cancelar"
              icon="pi pi-times"
              className="p-button-text"
              onClick={hideDialogPassword}
            />

            <Button
              label="Aprobar"
              icon="pi pi-check"
              className="p-button-success"
              loading={validandoPassword}
              onClick={aprobarSolicitud}
            />
          </div>
        }
      >
        <div className="d-flex flex-column gap-3">
          <p style={{ margin: 0 }}>
            Para aprobar la solicitud{" "}
            <strong>{solicitudSeleccionada?.Correlativo}</strong>, ingrese su
            contraseña.
          </p>

          <span className="p-float-label">
            <Password
              id="passwordAprobacion"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              feedback={false}
              toggleMask
              style={{ width: "100%" }}
              inputStyle={{ width: "100%" }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  aprobarSolicitud();
                }
              }}
            />
            <label htmlFor="passwordAprobacion">Contraseña</label>
          </span>
        </div>
      </Dialog>

      {dialogReporte && (
        <ReporteSolicitudEdicionProveedor
          dialog={dialogReporte}
          hideDialog={hideReporte}
          IdSolicitudEdicion={reporteData.IdSolicitudEdicion}
        />
      )}
    </div>
  );
};

export default SolicitudEdicionProveedoresScreen;
